import * as React from 'react';

import {BusinessPill} from '../acorn-pill/svg/business';
import {ClassicPill} from '../acorn-pill/svg/classic';
import {EngagementFoundationPill} from '../acorn-pill/svg/engagement-foundation';
import {EngagementProPill} from '../acorn-pill/svg/engagement-pro';
import {EnterprisePill} from '../acorn-pill/svg/enterprise';
import {FoundationPill} from '../acorn-pill/svg/foundation';
import {GrowthPill} from '../acorn-pill/svg/growth';
import {MarketingFoundationPill} from '../acorn-pill/svg/marketing-foundation';
import {MarketingProPill} from '../acorn-pill/svg/marketing-pro';
import {ProPill} from '../acorn-pill/svg/pro';
import {ProPlusPill} from '../acorn-pill/svg/pro-plus';
import {StarterPill} from '../acorn-pill/svg/starter';

import {
    NUTSHELL_PRO_ANNUAL,
    NUTSHELL_PRO_MONTHLY,
    NUTSHELL_BUSINESS_ANNUAL,
    NUTSHELL_BUSINESS_MONTHLY,
    ENGAGEMENT_FOUNDATION_MONTHLY,
    ENGAGEMENT_PRO_MONTHLY,
    MARKETING_FOUNDATION_MONTHLY,
    MARKETING_PRO_MONTHLY,
    // @ts-expect-error
} from './consts';
import type {Product} from './types';

export function getIconByKey(planKey: string) {
    switch (planKey) {
        case 'foundation':
            return <FoundationPill height={24} />;
        case 'growth':
            return <GrowthPill height={24} />;
        case 'pro':
            return <ProPill height={24} />;
        case 'business':
            return <BusinessPill height={24} />;
        case 'enterprise':
            return <EnterprisePill height={24} />;
    }
}

export function getIcon(planCode: string) {
    switch (planCode) {
        case 'ns-uud-a':
        case 'ns-uud-m':
            return <FoundationPill height={34} />;
        case ENGAGEMENT_FOUNDATION_MONTHLY:
            return <EngagementFoundationPill height={34} />;
        case MARKETING_FOUNDATION_MONTHLY:
            return <MarketingFoundationPill height={34} />;
        case MARKETING_PRO_MONTHLY:
            return <MarketingProPill height={34} />;
        case 'ns-uua-a':
        case 'ns-uua-q':
        case 'ns-uua-m':
            return <StarterPill height={34} />;
        case 'ns-uu-m':
        case 'ns-uu-a':
            return <ClassicPill height={34} />;
        case 'ns-uub-a-four':
        case NUTSHELL_PRO_ANNUAL:
        case 'ns-uub-sa':
        case 'ns-uub-q2023':
        case 'ns-uub-q':
        case NUTSHELL_PRO_MONTHLY:
            return <ProPill height={34} />;
        case ENGAGEMENT_PRO_MONTHLY:
            return <EngagementProPill height={34} />;
        case 'ns-uuc-a':
        case 'ns-uuc-q':
        case 'ns-uuc-m':
            return <ProPlusPill height={34} />;
        case 'ns-uue-a':
        case 'ns-uue-m':
        case 'ns-uue-m-annual':
            return <EnterprisePill height={34} />;
        case NUTSHELL_BUSINESS_ANNUAL:
        case NUTSHELL_BUSINESS_MONTHLY:
            return <BusinessPill height={34} />;
        case 'ns-uug-a':
        case 'ns-uug-m':
            // Actual Pill icon will go here once we have it
            return <GrowthPill height={34} />;

        default:
            return null;
    }
}

export const getProductItemizedName = (productKey: Product) => {
    switch (productKey) {
        case 'MARKETING':
            return 'contacts';
        case 'NUTSHELL_IQ':
            return 'credits';
        case 'REVENUE_BOOSTER':
        case 'INBOX':
        case 'SMS_CAMPAIGNS':
            return 'texts';
        default:
            return '';
    }
};
